require('../../modules/core.regexp.escape');
module.exports = require('../../modules/_core').RegExp.escape;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/fn/regexp/escape.js
// module id = 434
// module chunks = 0